"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*! js-cookie v2.2.0 | MIT */
!function (e) {
    var n = !1;if ("function" == typeof define && define.amd && (define(e), n = !0), "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && (module.exports = e(), n = !0), !n) {
        var o = window.Cookies,
            t = window.Cookies = e();t.noConflict = function () {
            return window.Cookies = o, t;
        };
    }
}(function () {
    function e() {
        for (var e = 0, n = {}; e < arguments.length; e++) {
            var o = arguments[e];for (var t in o) {
                n[t] = o[t];
            }
        }return n;
    }function n(o) {
        function t(n, r, i) {
            var c;if ("undefined" != typeof document) {
                if (arguments.length > 1) {
                    if ("number" == typeof (i = e({ path: "/" }, t.defaults, i)).expires) {
                        var a = new Date();a.setMilliseconds(a.getMilliseconds() + 864e5 * i.expires), i.expires = a;
                    }i.expires = i.expires ? i.expires.toUTCString() : "";try {
                        c = JSON.stringify(r), /^[\{\[]/.test(c) && (r = c);
                    } catch (e) {}r = o.write ? o.write(r, n) : encodeURIComponent(r + "").replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent), n = (n = (n = encodeURIComponent(n + "")).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)).replace(/[\(\)]/g, escape);var s = "";for (var f in i) {
                        i[f] && (s += "; " + f, !0 !== i[f] && (s += "=" + i[f]));
                    }return document.cookie = n + "=" + r + s;
                }n || (c = {});for (var p = document.cookie ? document.cookie.split("; ") : [], d = /(%[0-9A-Z]{2})+/g, u = 0; u < p.length; u++) {
                    var l = p[u].split("="),
                        C = l.slice(1).join("=");this.json || '"' !== C.charAt(0) || (C = C.slice(1, -1));try {
                        var m = l[0].replace(d, decodeURIComponent);if (C = o.read ? o.read(C, m) : o(C, m) || C.replace(d, decodeURIComponent), this.json) try {
                            C = JSON.parse(C);
                        } catch (e) {}if (n === m) {
                            c = C;break;
                        }n || (c[m] = C);
                    } catch (e) {}
                }return c;
            }
        }return t.set = t, t.get = function (e) {
            return t.call(t, e);
        }, t.getJSON = function () {
            return t.apply({ json: !0 }, [].slice.call(arguments));
        }, t.defaults = {}, t.remove = function (n, o) {
            t(n, "", e(o, { expires: -1 }));
        }, t.withConverter = n, t;
    }return n(function () {});
});

// On ready
$(document).ready(function () {
    // Cookie notice
    var $cookiesbar = $('#cookies-bar');
    if ($cookiesbar.length) {
        $cookiesbar.click(function () {
            Cookies.set('cookie_notice', 'yes', { expires: 30, path: '/' });
            $cookiesbar.fadeOut(200);
        });
    }

    // Custom scrollbar
    var $scrollBar = $('.scrollbar');
    if ($scrollBar.length) {
        $scrollBar.mCustomScrollbar({
            axis: "y",
            alwaysShowScrollbar: 0,
            theme: "dark"
        });
    }

    // Dynamic table
    var $tableSort = $('.table-sort');
    if ($tableSort.length) {
        $.tablesorter.defaults.sortList = [[0, 0]];
        $tableSort.tablesorter();
    }

    // Content img adjustments
    var $contentImg = $('.contenu img');
    if ($contentImg.length) {
        $contentImg.each(function () {
            var $me = $(this);
            var style = $me.attr('style');

            if (style) {
                if (style.indexOf('float:left') > -1) {
                    $me.css('margin-right', '20px');
                } else if (style.indexOf('float:right') > -1) {
                    $me.css('margin-left', '20px');
                } else {
                    $me.css('display', 'block').css('margin-top', '20px').css('margin-bottom', '20px');
                }
            } else {
                $me.css('display', 'block').css('margin-top', '20px').css('margin-bottom', '20px');
            }
        });
    }

    // *********************************************************************
    // MOBILE
    // *********************************************************************
    var $menuMobile = $('#menu-mobile');
    if ($menuMobile.length) {
        $menuMobile.click(function (e) {
            e.preventDefault();
            $(this).toggleClass('active');
            $('#menu').slideToggle(250);
        });
    }

    // *********************************************************************
    // TEAM
    // *********************************************************************
    var $team = $('.team');
    if ($team.length) {
        $team.each(function () {
            var $this = $(this);
            var $header = $this.children('.team-header');
            var $content = $this.children('.team-content');

            $header.click(function (e) {
                e.preventDefault();
                if (!$this.hasClass('active')) {

                    $('.team.active .team-content').slideUp(350, 'easeOutQuart', function () {
                        $(this).parents('.team').removeClass('active');
                    });

                    $content.slideDown(350, 'easeOutQuart', function () {
                        $this.addClass('active');
                    });
                }
            });
        });
    }

    // *********************************************************************
    // TABLE
    // *********************************************************************
    var $table = $('.table-inputs .button-new-entry');
    if ($table.length) {
        $table.click(function (e) {
            e.preventDefault();
            var $me = $(this);
            var n = parseInt($me.data('n'));
            if (!n) n = 4;
            $me.siblings('.table').append('<tr>' + '<td><input value="' + (n - 2) + '" disabled="disabled" type="text">' + '<input name="contact_' + n + '_type" value="autre" type="hidden"></td>' + '<td><input name="contact_' + n + '_nom" type="text"></td>' + '<td><input name="contact_' + n + '_ville" type="text"></td>' + '<td><input name="contact_' + n + '_pays" type="text"></td>' + '<td><input name="contact_' + n + '_structure" type="text"></td>' + '<td><input name="contact_' + n + '_email" type="text"></td>' + '<td><input name="contact_' + n + '_fonction" type="text"></td>' + '</tr>');
            $me.data('n', ++n);
        });
    }

    // *********************************************************************
    // HOME SLIDER
    // *********************************************************************
    var $imagesBg = $('#images-bg .images');
    if ($imagesBg.length) {
        var resize = function resize() {
            var win_width = $(window).width();
            $imagesBg.find('.image').width(win_width);
            $imagesBg.width(nb_slides * win_width).css({ left: -(win_width * (current_slide_n - 1)) });
        };

        var home_slide = function home_slide(n) {
            if (n != current_slide_n && !sliding) {
                sliding = true;
                var offset = 300;

                if (!n) {
                    current_slide_n++;
                    n = current_slide_n;
                    if (n > nb_slides) {
                        n = current_slide_n = 1;
                    }
                } else {
                    current_slide_n = n;
                }

                var $current_slide = $('#header #slider .content .home-slider .slide.active');
                var $slide = $('#header #slider .content .home-slider #slide-' + n);

                $('#header #slider .content .home-slider .pagination .pages li.active').removeClass('active');
                $('#header #slider .content .home-slider .pagination .pages li[data-n="' + n + '"]').addClass('active');

                $current_slide.find('.title').animate({ right: offset, opacity: 0 }, 500, 'easeOutQuart');
                $current_slide.find('.description').delay(150).animate({ right: offset, opacity: 0 }, 500, 'easeOutQuart');
                $current_slide.find('.buttons').delay(300).animate({ right: offset, opacity: 0 }, 500, 'easeOutQuart', function () {
                    $current_slide.removeClass('active');
                    $('#images-bg .images').animate({ left: -($(window).width() * (n - 1)) }, 2000, 'easeOutQuart');
                });

                $slide.addClass('active').find('.title, .description, .buttons').fadeTo(0, 0).css('right', '-' + offset + 'px');
                $slide.find('.title').delay(1000).animate({ right: 0, opacity: 1 }, 250, 'easeOutQuart');
                $slide.find('.description').delay(1150).animate({ right: 0, opacity: 1 }, 250, 'easeOutQuart');
                $slide.find('.buttons').delay(1300).animate({ right: 0, opacity: 1 }, 250, 'easeOutQuart', function () {
                    $slide.addClass('active');
                    sliding = false;
                });
            }
        };

        var auto_slider = function auto_slider() {
            setTimeout(function () {
                home_slide();
                auto_slider();
            }, 8000);
        };

        var nb_slides = $('#header #slider .content .home-slider .slide').length;
        var current_slide_n = 1;
        var sliding = false;

        resize();
        $(window).resize(resize);

        $('#header #slider .content .home-slider .pagination .pages li').on('click', function () {
            home_slide($(this).data('n'));
        });

        auto_slider();
    }

    // ********************************************************
    // NOTIFICATIONS
    // ********************************************************
    function notif(data) {
        var type = 'error';
        if (!data.error) type = 'valid';
        var $notifMessage = $('<div class="notification ' + type + '"><p>' + data.message + '</p></div>').fadeTo(0, 0).hide();
        $('#notifications').append($notifMessage);
        show_notif($notifMessage);
    }
    function show_notif($notifMessage) {
        $notifMessage.fadeTo(0, 0).show();
        var top = $notifMessage.position().top;
        $notifMessage.css('top', top - 100 + 'px').delay(500).animate({ top: top, opacity: 1 }, 350, 'easeOutQuart').delay(4000).animate({ top: top - 100, opacity: 0 }, 350, 'easeOutQuart', function () {
            $(this).remove();
        });
    }
    function hide_notif($notifMessage) {
        $notifMessage.stop().animate({ top: -80, opacity: 0 }, 350, 'easeOutQuart', function () {
            $(this).remove();
        });
    }

    $('#notifications').on('click', '.notification', function (e) {
        e.preventDefault();
        $(this).stop();
        hide_notif($(this));
    });

    $('#notifications .notification').each(function () {
        show_notif($(this));
    });

    // *********************************************************************
    // FORM
    // *********************************************************************
    var $form = $('.form');
    if ($form.length) {
        $form.submit(function (e) {
            e.preventDefault();
            var form = $(this);
            if (!form.hasClass('loading')) {
                form.addClass('loading');
                form.find('.error').removeClass('error');
                form.find('.error-message').remove();
                $.post(form.attr('action'), form.serialize(), function (data) {
                    form.removeClass('loading');

                    if (!data.error) {
                        if (data.redirect) {
                            location.href = data.redirect;
                        } else {
                            notif(data);
                            form.find('input, textarea, select').val('').blur();
                        }
                    }

                    if (data.error && !data.errors) {
                        notif(data);
                    }

                    if (data.errors) {
                        var f = true;
                        for (var i in data.errors) {
                            if (f) $('html, body').animate({ scrollTop: form.find('*[name="' + i + '"]').parent().offset().top - 80 }, 500, 'easeOutQuart');
                            form.find('*[name="' + i + '"]').parent().addClass('error').after('<div class="error-message"><span class="icon"></span><p class="text"><span class="arrow"></span>' + data.errors[i] + '</p></div>');
                            f = false;
                        }
                    }
                }, 'json').always(function () {
                    form.removeClass('loading');
                });
            }
        });

        $form.on('mouseenter', '.error-message .icon', function () {
            $(this).siblings('.text').stop().fadeTo(0, 0).css('left', '20px').show().animate({ left: 0, opacity: 1 }, 250, 'easeOutQuart');
        });

        $form.on('mouseout', '.error-message .icon', function () {
            $(this).siblings('.text').stop().fadeTo(0, 1).css('left', '0').show().animate({ left: 20, opacity: 0 }, 250, 'easeOutQuart', function () {
                $(this).hide();
            });
        });
    }

    var $inputTxt = $('.input, .textarea');
    if ($inputTxt.length) {
        $inputTxt.each(function () {
            var $me = $(this);
            var $label = $me.find('label');
            var $input = $me.find('input, select, textarea');

            if (!$me.hasClass('two-lines')) $input.css('width', $me.outerWidth() - $label.outerWidth() - 10);

            //me.on('click', function(e) {
            //	input.focus();
            //});

            $input.on('focus', function (e) {
                $me.addClass('focus');
            });

            $input.on('blur', function (e) {
                $me.removeClass('focus');
            });
        });
    }

    // Newsletter form
    var $newsletterForm = $('.form-newsletter');
    if ($newsletterForm.length) {
        // Float labels
        //var floatlabels = new FloatLabels( '.form-newsletter');

        $newsletterForm.find('input').each(function () {
            var $this = $(this);
            $this.css('paddingLeft', parseInt($this.parent().find('label').width()) + 20);
        });

        $newsletterForm.submit(function (e) {
            e.preventDefault();

            // Validation
            var validation = true;
            $newsletterForm.find('input[required]').each(function () {
                var $this = $(this);
                if (!$this.val().length) {
                    $this.parent().addClass('input-error');
                    validation = false;
                }
            });

            // Send form
            if (validation) {
                var $submit = $newsletterForm.find('button');
                $submit.data('oldText', $submit.text()).text($submit.data('loading'));

                $.ajax({
                    method: 'post',
                    data: $newsletterForm.serialize(),
                    url: $newsletterForm.attr('action'),
                    dataType: 'json',
                    success: function success(data) {
                        if (data.message) {
                            var $newsletterAlert = $newsletterForm.find('.newsletter-alert');
                            $newsletterAlert.html(data.message).fadeIn();

                            if (data.error) {
                                $newsletterAlert.addClass('newsletter-error');
                            } else {
                                // Reset form
                                $newsletterForm.trigger('reset');

                                $newsletterAlert.removeClass('newsletter-error');
                            }
                        }

                        // Reset button
                        $submit.text($submit.data('oldText'));
                    },
                    error: function error() {
                        $submit.text($submit.data('oldText'));
                    }
                });
            }
        });

        $newsletterForm.find('input[required]').on('keyup keydown', function () {
            var $this = $(this);
            if ($this.val().length) {
                $this.parent().removeClass('input-error');
            }
        });
    }
});

// On load
$(window).load(function () {
    // *********************************************************************
    // TABS
    // *********************************************************************
    var $tabs = $('.tabs .tab');
    if ($tabs.length) {
        $tabs.each(function () {
            var $me = $(this);
            var tab_height = $me.parent().outerHeight();
            var text_height = $me.find('.text').outerHeight();
            console.log((tab_height - text_height) / 2);
            $me.css('padding-top', (tab_height - text_height) / 2 + 'px').css('padding-bottom', (tab_height - text_height) / 2 + 'px');
        });
    }
});
//# sourceMappingURL=app.js.map
